import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import { connect } from 'react-redux';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MenuItem from '@mui/material/MenuItem';
import IntlMessages from '../../util/IntlMessages';
import Comeback from '../../components/comeback';
import * as petrolStation from '../../appRedux/actions/petrol_station';
import LoadingButton from '@mui/lab/LoadingButton';
import * as info from '../../appRedux/actions/info';
import Card from '@mui/material/Card';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import * as constants from '../../constants';

function RefuelTanker(props) {
  const [tab, setTab] = useState(0);
  const [liter, setLiter] = useState('');
  const [fuelCard, setFuelCard] = useState('');
  const [petrolStation, setPetrolStation] = useState('');
  const [petrolStationList, setPetrolStationList] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    getPetrolStationList();
    props.operatorProfileAction();
  }, []);

  const getPetrolStationList = async () => {
    const result = await props.petrolStationListAction();
    setPetrolStationList(result);
  };

  const refuelTankerHandlerClick = async () => {
    await props.petrolStationRefuelTankerAction({
      iVolume: liter,
      vFuelCard: fuelCard,
      iPersonType: constants.PERSON_TYPE,
      vPetrolStationCode: petrolStation,
      vFuelType: tab === 0 ? 'Euro' : 'Gasoline',
      vPetrolStationName: petrolStationList.find(
        (obj) => obj.vPetrolStationCode === petrolStation,
      ).vPetrolStationName,
    });

    setPetrolStation('');
    setFuelCard('');
    setLiter('');
  };

  const handleChange = (event, newValue) => {
    setTab(newValue);
    setFuelCard('');
    setLiter('');
    setPetrolStation('');
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmRefuel = async () => {
    setOpenDialog(false);
    await refuelTankerHandlerClick();
  };

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={6} md={6}>
          <Comeback title={<IntlMessages id="addRefuelTanker" />} />
        </Grid>
      </Grid>
      <br />
      <Card style={{ margin: 10, padding: 20 }}>
        {!props.field.profile.vFuelCarCode && (
          <Alert variant="filled" severity="warning">
            <IntlMessages id="refuelTankerAlertFuelCar" />
          </Alert>
        )}
        <Tabs
          variant="fullWidth"
          indicatorColor="secondary"
          textColor="secondary"
          centered
          value={tab}
          onChange={handleChange}
        >
          <Tab label={<IntlMessages id="gasolineLoadingRecord" />} />
          <Tab label={<IntlMessages id="dieselLoadingRegistration" />} />
        </Tabs>
        <div
          style={{
            marginTop: 20,
            backgroundColor: tab === 0 ? '#EF9A9A' : '#FFCC80',
            padding: 20,
            borderRadius: 10,
          }}
        >
          <TextField
            value={petrolStation}
            onChange={(e) => setPetrolStation(e.target.value)}
            select
            fullWidth
            label={<IntlMessages id="petrolStation" />}
            variant="filled"
          >
            {petrolStationList.map((option) => (
              <MenuItem key={option.vPetrolStationCode} value={option.vPetrolStationCode}>
                {option.vPetrolStationName}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,4}(\.\d{0,2})?$/.test(value)) {
                setLiter(value);
              }
            }}
            value={liter}
            fullWidth
            required
            type="text"
            margin="normal"
            label={<IntlMessages id="litrage" />}
            variant="filled"
          />

          <TextField
            value={fuelCard}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,4}$/.test(value)) {
                setFuelCard(value);
              }
            }}
            fullWidth
            required
            type="number"
            margin="normal"
            label={
              tab === 0 ? (
                <IntlMessages id="fuelCard" />
              ) : (
                <IntlMessages id="gasolineCard" />
              )
            }
            variant="filled"
            helperText={
              tab === 0 ? (
                <IntlMessages id="pleaseEnterLast4DigitsYourFuelCard" />
              ) : (
                <IntlMessages id="pleaseEnterLast4DigitsYourGasolineCard" />
              )
            }
          />

          <LoadingButton
            onClick={handleOpenDialog}
            loading={props.loadingBtn}
            disabled={!petrolStation || !liter}
            variant="contained"
            fullWidth
            size="large"
            color="primary"
          >
            <IntlMessages id="addRefuelTanker" />
          </LoadingButton>
        </div>
      </Card>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          <IntlMessages id="confirmRefuel" />
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            <IntlMessages id="areYouSureRefuelTanker" />
          </DialogContentText>

          <div style={{ marginTop: 16 }}>
            <p>
              <strong>
                <IntlMessages id="litrage" />:
              </strong>{' '}
              {liter}
            </p>
            <p>
              <strong>
                <IntlMessages id="fuelCard" />:
              </strong>{' '}
              {fuelCard}
            </p>
            <p>
              <strong>
                <IntlMessages id="petrolStation" />:
              </strong>{' '}
              {petrolStationList.find((obj) => obj.vPetrolStationCode === petrolStation)
                ?.vPetrolStationName || ''}
            </p>
            <p>
              <strong>
                <IntlMessages id="fuelType" />:
              </strong>{' '}
              {tab === 0 ? <IntlMessages id="euro" /> : <IntlMessages id="gasoline" />}
            </p>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleConfirmRefuel} variant='contained' color="secondary" autoFocus>
            <IntlMessages id="confirmation" />
          </Button>
          <Button onClick={handleCloseDialog} variant='outlined' color="primary">
            <IntlMessages id="iGaveUp" />
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    field: state.field,
    loadingBtn: state.common.loadingBtn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    operatorProfileAction: () => dispatch(info.operatorProfileAction()),
    petrolStationListAction: () => dispatch(petrolStation.petrolStationListAction()),
    petrolStationRefuelTankerAction: (data) =>
      dispatch(petrolStation.petrolStationRefuelTankerAction(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RefuelTanker);
